import React from 'react';
import { motion } from 'framer-motion';
import { Phone, Mail, MapPin, Facebook, Twitter, Linkedin, Instagram, Building2 } from 'lucide-react';
import { useSettings } from '../context/SettingsContext'; // Importar useSettings

const Footer = () => {
  const { settings } = useSettings();

  return (
    <motion.footer
      className="bg-gray-900 text-gray-300 py-10 mt-12"
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.5 }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-3 gap-8">
        {/* Columna 1: Logo y Descripción */}
        <div className="flex flex-col items-center md:items-start text-center md:text-left">
          <motion.div 
            className="flex items-center gap-2 mb-4"
            initial={{ scale: 0.8 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.5 }}
          >
            {settings.companyLogoUrl ? (
              <img src={settings.companyLogoUrl} alt="Company Logo" className="w-10 h-10 rounded-xl object-cover" />
            ) : (
              <div className="w-10 h-10 bg-gradient-to-r from-blue-600 to-purple-600 rounded-xl flex items-center justify-center">
                <Building2 className="w-6 h-6 text-white" />
              </div>
            )}
            <span className="text-2xl font-bold text-white">{settings.companyName}</span>
          </motion.div>
          <p className="text-sm leading-relaxed">
            Chirak Tour Operator & Gray Line Chile
          </p>
        </div>

        {/* Columna 2: Información de Contacto */}
        <div className="text-center md:text-left">
          <h3 className="text-lg font-semibold text-white mb-4">Contáctanos</h3>
          <ul className="space-y-3">
            {settings.phone && (
              <li className="flex items-center justify-center md:justify-start gap-3">
                <Phone className="w-5 h-5 text-blue-400" />
                <span>{settings.phone}</span>
              </li>
            )}
            {settings.email && (
              <li className="flex items-center justify-center md:justify-start gap-3">
                <Mail className="w-5 h-5 text-blue-400" />
                <span>{settings.email}</span>
              </li>
            )}
            {settings.address && (
              <li className="flex items-center justify-center md:justify-start gap-3">
                <MapPin className="w-5 h-5 text-blue-400" />
                <span>{settings.address}</span>
              </li>
            )}
          </ul>
        </div>

        {/* Columna 3: Redes Sociales */}
        <div className="text-center md:text-left">
          <h3 className="text-lg font-semibold text-white mb-4">Síguenos</h3>
          <div className="flex justify-center md:justify-start gap-4">
            {settings.social.facebook && (
              <motion.a 
                href={settings.social.facebook} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-gray-400 hover:text-white transition-colors"
                whileHover={{ scale: 1.2 }}
                whileTap={{ scale: 0.9 }}
              >
                <Facebook className="w-7 h-7" />
              </motion.a>
            )}
            {settings.social.twitter && (
              <motion.a 
                href={settings.social.twitter} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-gray-400 hover:text-white transition-colors"
                whileHover={{ scale: 1.2 }}
                whileTap={{ scale: 0.9 }}
              >
                <Twitter className="w-7 h-7" />
              </motion.a>
            )}
            {settings.social.linkedin && (
              <motion.a 
                href={settings.social.linkedin} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-gray-400 hover:text-white transition-colors"
                whileHover={{ scale: 1.2 }}
                whileTap={{ scale: 0.9 }}
              >
                <Linkedin className="w-7 h-7" />
              </motion.a>
            )}
            {settings.social.instagram && (
              <motion.a 
                href={settings.social.instagram} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-gray-400 hover:text-white transition-colors"
                whileHover={{ scale: 1.2 }}
                whileTap={{ scale: 0.9 }}
              >
                <Instagram className="w-7 h-7" />
              </motion.a>
            )}
          </div>
        </div>
      </div>

      <div className="mt-10 pt-6 border-t border-gray-700 text-center text-sm text-gray-500">
        © {new Date().getFullYear()} {settings.companyName}. Todos los derechos reservados.
      </div>
    </motion.footer>
  );
};

export default Footer;